import { HttpResponse } from 'msw';

type LegacyBody = { command?: string; access?: string };

export function handleUsbApiLegacy(
  body: LegacyBody,
): ReturnType<typeof HttpResponse.json> {
  const command = body.command ?? '';
  const access = body.access ?? 'get';

  switch (command) {
    case 'state':
      if (access === 'get') {
        return HttpResponse.json({ state: false }, { status: 200 });
      }
      if (access === 'set') {
        return HttpResponse.json({ ok: true }, { status: 200 });
      }
      break;
    default:
      break;
  }

  return HttpResponse.json(
    { error: 'not implemented', msg: `Mock missing for usbapi:${command}` },
    { status: 400 },
  );
}
